import React, { useState, useEffect } from 'react';
import './BannerCarousel.css';

const BannerCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [preloadedImages, setPreloadedImages] = useState(new Set());

  useEffect(() => {
    // Preload all banner images
    const slides = [
      '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__3442.webp',
      '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__24137.webp',
      '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__13648.webp'
    ];

    slides.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        setPreloadedImages((prev) => new Set([...prev, src]));
      };
    });
  }, []);

  const slides = [
    {
      id: 1,
      title: 'Book My',
      subtitle: 'decorations',
      description: 'Transform your celebrations with elegance and style',
      image: '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__3442.webp'
    },
    {
      id: 2,
      title: 'Elegant',
      subtitle: 'Balloon Arrangements',
      description: 'Creating unforgettable memories for every occasion',
      image: '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__24137.webp'
    },
    {
      id: 3,
      title: 'Premium',
      subtitle: 'Event Decorations',
      description: 'Specializing in creative and customized designs',
      image: '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__13648.webp'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section className="banner-carousel">
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ 
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div className="slide-content">
              <div className="slide-text">
                <h1 className="slide-title">
                  <span className="title-main">{slide.title}</span>
                  <span className="title-sub">{slide.subtitle}</span>
                </h1>
                <p className="slide-description">{slide.description}</p>
                <a href="https://wa.me/9166007718" className="cta-button" target="_blank" rel="noopener noreferrer">Explore Our Services</a>
              </div>
            </div>
          </div>
        ))}
        
        <button className="carousel-btn prev" onClick={goToPrevious}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <button className="carousel-btn next" onClick={goToNext}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>

        <div className="carousel-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BannerCarousel;
